import { render, staticRenderFns } from "./AdmissionFormSbpps.vue?vue&type=template&id=219e8dfc&scoped=true&style=background-color%3A%20white%3B&"
import script from "./AdmissionFormSbpps.vue?vue&type=script&lang=js&"
export * from "./AdmissionFormSbpps.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionFormSbpps.vue?vue&type=style&index=0&id=219e8dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e8dfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VImg,VRow,VSimpleTable})
